import { MeshReflectorMaterial } from "@components/lib/MeshReflectorMaterial";
import { Euler } from "@react-three/fiber";
import { useMemo } from "react";

export function Reflector({ mobile }: { mobile: boolean }) {
    const rotation = useMemo<Euler>(() => [-Math.PI * 0.5, 0, 0], []);
    const size = useMemo<[number, number]>(() => [50, 50], []);
    const blur = useMemo<[number, number]>(() => [400, 100], []);
    return (
        <mesh rotation={rotation}>
            <planeGeometry args={size} />
            <MeshReflectorMaterial
                resolution={mobile ? 1024 : 2048}
                mirror={1}
                blur={blur}
                mixBlur={1}
                mixStrength={2}
                depthScale={0.7}
                minDepthThreshold={0.6}
                maxDepthThreshold={1.5}
                color="#ffffff"
                metalness={0.8}
            />
        </mesh>
    );
}